import React from 'react';
import './Footer.css';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t, i18n } = useTranslation();
  const scrollToTop = () => {
    const duration = 1000; // duration in ms
    const start = window.scrollY || window.pageYOffset;
    const startTime = performance.now();
    
    function easeInOutQuad(t) {
      return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    }

    function animateScroll(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const ease = easeInOutQuad(progress);
      window.scrollTo(0, start * (1 - ease));
      if (elapsed < duration) {
        requestAnimationFrame(animateScroll);
      }
    }
    requestAnimationFrame(animateScroll);
  };
  
  return (
    <footer className="footer bg-dark text-white py-4">
      <div className="container">
        <div className="row">
          {/* First Column */}
          <div className="col-md-6">
            <h5><a href="mailto:hello@ondrejstaidl.com" className="footer-contact-link">hello@ondrejstaidl.com</a></h5>
            <h5>+420 735 294 782</h5>
          </div>
          <div className="footer-social-links">
            <a href="https://www.instagram.com/ondrejstaidl/" target="_blank" rel="noopener noreferrer">
              <svg className="arrow-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L12 22M12 22L5 15M12 22L19 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Instagram
            </a>
            <a href="https://www.youtube.com/@ondrejstaidl" target="_blank" rel="noopener noreferrer">
              <svg className="arrow-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L12 22M12 22L5 15M12 22L19 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              YouTube
            </a>
            <a href="https://www.linkedin.com/in/ondrej-staidl-3642b7ba/" target="_blank" rel="noopener noreferrer">
              <svg className="arrow-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L12 22M12 22L5 15M12 22L19 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              LinkedIn
            </a>
            <a href="https://herohero.co/ondrejstaidl" target="_blank" rel="noopener noreferrer">
              <svg className="arrow-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L12 22M12 22L5 15M12 22L19 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Herohero
            </a>
          </div>
          <div className="col-md-6">
            <div className="info-container">
              <h6>{t('footer.info.companyDetails')}</h6>
              <div className="legal-links">
                <a href={`/privacypolicy?lang=${i18n.language}`} className="privacy-link">
                  <svg className="arrow-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L12 22M12 22L5 15M12 22L19 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  {t('footer.info.privacyPolicy')}
                </a>
                <a href={`/storno?lang=${i18n.language}`} className="privacy-link storno-link">
                  <svg className="arrow-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L12 22M12 22L5 15M12 22L19 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  {t('footer.info.cancellationPolicy')}
                </a>
              </div>
            </div>
            <p>© {new Date().getFullYear()} <a href="https://amahi.co" target="_blank" rel="noopener noreferrer" className="amahi-link">amahi.co</a></p>
          </div>
          
          {/* Second Column */}
          <div className="col-md-6 position-relative">
          <button onClick={scrollToTop} className="btn-custom position-absolute bottom-0 end-0 mb-3 me-3">
            {t('footer.buttons.goToTop')}
          </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
